import axiosInstance from './axios';

export const wagerConfigService = {
  getWagerCategories: (siteId: string | number) =>
    axiosInstance.get('/admin/wager-multiplier-categories', { params: { siteId } }),
  getWagerSubCategories: (siteId: string | number, categoryId: string | number) =>
    axiosInstance.get('/admin/wager-multiplier-categories/sub-categories', {
      params: { siteId, categoryId },
    }),
  updateWagerCategory: (id: number, data: { multiplier?: string; isActive?: boolean }) =>
    axiosInstance.patch(`/admin/wager-multiplier-categories/sub-categories/${id}`, data),
};
